var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"page-wrapper"},[(_vm.$route.meta.keepAlive)?_c('keep-alive',[_c('router-view',{staticClass:"page-content"})],1):_c('router-view',{staticClass:"page-content"})],1),_c('global-modals'),(_vm.$socket.isConnected)?_c('Notifier'):_vm._e(),_c('update-notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }